import React from 'react';

import { EOfferFormatKey } from '../../../StoreSettings.types';
import { ABBREVIATIONS_V2_TEXTS } from '../AbbreviationsSettingsV2.consts';
import {
  SettingsFieldPath,
  SettingsFieldValue
} from '../AbbreviationsSettingsV2.types';

import { SectionHeading } from './SectionHeading';
import { TimeFormatPanel } from './TimeFormatPanel';

interface ITimeFormatSectionProps {
  sectionKey: EOfferFormatKey;
  onCommit: (path: SettingsFieldPath, value: SettingsFieldValue) => void;
}

export const TimeFormatSection = ({
  sectionKey,
  onCommit
}: ITimeFormatSectionProps): React.ReactElement => (
  <div className="flex flex-col gap-5">
    <SectionHeading title={ABBREVIATIONS_V2_TEXTS.TIME_SECTION_TITLE} />
    <TimeFormatPanel sectionKey={sectionKey} onCommit={onCommit} />
  </div>
);
